import { EntityTagFilter } from '@backstage/plugin-catalog-react';
import { Icon } from '@iconify/react';
import { isIPenPlatformDomainEntity } from '@ipen-portal/plugin-common';
import { makeEntityContentWithToolbar } from '@ipen-portal/plugin-layout-react';

import { LifecycleFilter } from '../../components/LifecycleFilter';

export const ApiListPageEntityContent = makeEntityContentWithToolbar({
  name: 'ApiListPageEntityContent',
  params: {
    filter: isIPenPlatformDomainEntity,
    icon: <Icon icon="material-symbols:description-outline" />,
    loader: async () =>
      import('./components/ApiList/ApiList').then(m => <m.ApiList />),
    path: '/apis',
    title: 'APIs',
    toolbarProps: {
      filter: [
        <LifecycleFilter
          key="lifecycle"
          visibleOptions={['in-ideation', 'in-integration', 'productive']}
        />,
      ],
    },
    wrapperProps: {
      kindFilter: 'api',
      staticFilter: {
        filterTag: new EntityTagFilter(['ipen-api']),
      },
      typeFilter: 'openapi',
    },
  },
});
